module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.354dc62.ttf";